import { render, staticRenderFns } from "./SendNewEmail.vue?vue&type=template&id=4db3bd6f&scoped=true&"
import script from "./SendNewEmail.vue?vue&type=script&lang=ts&"
export * from "./SendNewEmail.vue?vue&type=script&lang=ts&"
import style0 from "./SendNewEmail.vue?vue&type=style&index=0&id=4db3bd6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db3bd6f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4db3bd6f')) {
      api.createRecord('4db3bd6f', component.options)
    } else {
      api.reload('4db3bd6f', component.options)
    }
    module.hot.accept("./SendNewEmail.vue?vue&type=template&id=4db3bd6f&scoped=true&", function () {
      api.rerender('4db3bd6f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_messages/components/SendNewEmail.vue"
export default component.exports